import { render, staticRenderFns } from "./WirelessModules.vue?vue&type=template&id=f50ff0d8&"
import script from "./WirelessModules.vue?vue&type=script&lang=js&"
export * from "./WirelessModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports